// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"310":"exam","594":"about"}[chunkId] || chunkId) + "." + {"310":"399df09a","594":"a287b28f","696":"b2dae7ff"}[chunkId] + ".js";
};